import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

import { colors, OuterContainer } from "../../libs";

export const RegistrationPageContainer = styled(OuterContainer)`
  background-color: ${colors.background.black};
  padding: 0 15px;
  min-height: 100vh;
`;

export const RegistrationPageRow = styled(Row)``;

export const PackageInfoCol = styled(Col)``;

export const RegistrationHeader = styled.div`
  padding: 20px;
`;

export const RegistrationCol = styled(Col)`
  background-color: ${colors.background.lightBlack};
  min-height: 100vh;
  padding-top: 100px;
`;

export const LoadError = styled.div`
  align-items: center;
  color: ${colors.text.white};
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  min-height: calc(100vh - 100px);
  padding: 32px;
  text-align: center;

  p {
    color: ${colors.text.mediumWhite};
    margin: 0;
    max-width: 520px;
  }
`;
